import React, { useState } from "react";

import SearchBox from "./Searchbox.js";
import CityWeather from "./CityWeather.js";
import { City } from "../types/weatherTypes.js";
import { Cities } from "../types/cities.js";
import Statement from "./Statement.js";

interface WeatherForecastProps {
  className?: string;
}

const WeatherForecast: React.FC<WeatherForecastProps> = ({ className }) => {
  const [currentCity, setCurrentCity] = useState<City>(Cities[0]);

  return (
    <div className={className}>
      <div>
        <SearchBox className="mb-12 inline-block w-full rounded-lg border border-black bg-white fill-nearblack-100 sm:w-auto md:min-w-2xl lg:min-w-3xl" />
        {/* <div id="cityPicker" className="mb-6 flex flex-wrap justify-center gap-2">
        {Cities.map((city) => (
          <button
            key={city.id}
            onClick={() => setCurrentCity(city)}
            className={`rounded-full px-4 py-2 transition-colors ${currentCity.id === city.id ? "bg-red-500 text-white" : "bg-gray-200 hover:bg-gray-300"}`}
          >
            {city.name}
          </button>
        ))}
      </div> */}

        <div className="mb-8 rounded-xl bg-transparent p-6 shadow-xl shadow-nearblack-500">
          <CityWeather city={currentCity} className="text-white" />
          <Statement />
        </div>
      </div>
    </div>
  );
};

export default WeatherForecast;
